export enum OrderDataModelUpdateSource {
  OrderLifeCycleEvent,
  XferEvent,
  LockLifeCycleEvent,
  BulkOrderLifeCycleEvent,
  TrailingStopEvent,
}
